import { jsx } from "react/jsx-runtime";
const Checkmark = ({ className, color: colorProp = '#181B32', size = 32, ignoreColor })=>{
    const color = ignoreColor ? void 0 : colorProp;
    return /*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ jsx("path", {
            d: "M9.863 18a1 1 0 0 1-.729-.315l-4.863-5.179a1 1 0 1 1 1.457-1.369l4.125 4.391 8.408-9.202a1 1 0 0 1 1.477 1.348l-9.137 10a.998.998 0 0 1-.73.326h-.008Z",
            fill: color
        })
    });
};
const outline_Checkmark = Checkmark;
export default outline_Checkmark;
